export const SPIFF_APPROVAL_STATUSES = {
  pending: "pending",
  marked_as_paid: "marked_as_paid",
} as const;
